import React from 'react'
import BaseModal from './BaseModal'
import { faWallet } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import binance from '../../assets/images/binance.png'
import coinbase from '../../assets/images/coinbase.png'
import lunno from '../../assets/images/lunno.png'
import trustwallet from '../../assets/images/trustwallet.png'

const AddWallet = () => {
    const walletStyle = {
        width: '100%',
        height: '70px'
    }
    const wallets = [
        {
            id: 1,
            img: binance,
            alt: "Binance",
            link: ""
        },
        {
            id: 2,
            img: coinbase,
            alt: "Coinbase",
            link: "https://us-central1-liquifyapp-78f54.cloudfunctions.net/CoinbaseRedirect"
        },
        {
            id: 3,
            img: trustwallet,
            alt: "Trustwallet",
            link: ""
        },
        {
            id: 4,
            img: lunno,
            alt: "Lunno",
            link: ""
        }
    ]

    return (
        <BaseModal modalId="modalAddWallet" modalTitle="Connect new Wallet" modalTitleIcon={faWallet}>
            <div className="row p-3 d-flex justify-content-around">                
                {
                    wallets.map(wallet => {
                        return(
                            <Link key={wallet.id} to={{pathname: wallet.link}} target="_blank" rel="noreferrer" className="col-5 m-2 shadow btn"><img src={wallet.img} alt={wallet.alt} style={walletStyle} /></Link>
                        )
                    })
                }
            </div>
        </BaseModal>
    )
}

export default AddWallet